import React from "react";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";

export interface RegionNotAllowedTextProps {
  allowedRegions: string;
}

export const RegionNotAllowedText: React.FC<RegionNotAllowedTextProps> = ({
  allowedRegions,
}) => {
  const { t } = useTranslation("purchases");

  return (
    <Flex
      direction="column"
      width="100%"
      color="secondary.600"
      fontSize={{ base: "xs", sm: "sm" }}
    >
      <Text>
        {`${t(
          "Purchases are restricted to specific regions. Allowed regions are"
        )}: ${allowedRegions}.`}
      </Text>
      <Text>
        {t(
          "Please contact our support team if you are seeing this message in error."
        )}
      </Text>
    </Flex>
  );
};

export default RegionNotAllowedText;
